import React, { Component } from "react";
import IdentityService from "../../common/identityService";
import { Card, Form, Button, Row, Col, Container } from "react-bootstrap";
import PropTypes from "prop-types";
import "./registration.scss";

export default class RegisterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxChecked: true,  
      email: "",
      password1: "",
      password2: "",
      firstName: "",
      lastName: "",
      isPublic: false,
      DOB: "",
      registerClicked: false,
      successfullyRegistered: false
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.registerClicked === false &&
      this.state.registerClicked === true
    ) {

      let formValid = false;
      if (this.state.email === "" || 
          this.state.firstName === "" || 
          this.state.lastName === "" || 
          this.state.DOB === "" ||
          this.state.password1 === "" ||
          this.state.password2 === ""
        ){
          this.props.notifyFailure(
            "Please fill in all fields", 
            2000
          );
      } 
      else{
        formValid = true;
      }

      if (this.state.password1 !== this.state.password2){
        this.props.notifyFailure(
          "Passwords do not match",
          2000
        );
        formValid = false;
      }

      if (formValid === true){
        try {
          const response = await IdentityService.register(
            this.state.email,
            this.state.password1,
            this.state.firstName,
            this.state.lastName,
            this.state.isPublic,
            this.state.DOB
          );
          const username = response.user.username;
          // this.props.notifyInfo(
          //   "Successfully registered with email: " +
          //     username +
          //     ". Please tell an admin to confirm your registration",
          //     5000
          // );
          this.setState({
            successfullyRegistered: true
          });
        } catch (e) {
          this.props.notifyFailure(
            "Failed to register user. " + JSON.stringify(e.message), 
            3000
          );
        }
      }
      this.setState({
        registerClicked: false
      });
    }
  }

  onRegisterClicked = () => {
    this.setState({
      registerClicked: true
    });
  };

  handleChange = () => {
    this.setState({
        checkboxChecked: (!this.state.checkboxChecked),
    });
    this.setState({
        isPublic: (this.state.checkboxChecked),
    });
  }

  renderRegistrationForm() {
    return (
      <Form className="mb-2">
        <Form.Group as={Row} className="mb-0">
          <Col xs={6} className="pr-1">
            <Form.Control
              type="text"
              placeholder="First Name"
              onChange={event => {
                this.setState({
                  firstName: event.target.value
                });
              }}
            />
          </Col>
          <Col xs={6} className="pl-1">
            <Form.Control
              type="text"
              placeholder="Last Name"
              onChange={event => {
                this.setState({
                  lastName: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Control
              type="text"
              placeholder="Date of birth"
              onChange={event => {
                this.setState({
                  DOB: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Control
              type="email"
              placeholder="Enter email"
              onChange={event => {
                this.setState({
                  email: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Control
              type="password"
              placeholder="Password"
              onChange={event => {
                this.setState({
                  password1: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1">
          <Col md={8}>
            <Form.Control
              type="password"
              placeholder="Confirm password"
              onChange={event => {
                this.setState({
                  password2: event.target.value
                });
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  this.onRegisterClicked();
                }
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group className="mb-1">
            <Form.Check 
                type="checkbox" 
                label="Make account private"
                defaultChecked={this.state.checkboxChecked}
                onChange={this.handleChange}
            />
        </Form.Group>
        
        <Button className="w-100"variant="primary" onClick={this.onRegisterClicked}>
          Register
        </Button>
      </Form>
    );
  }

  render() {
    return (
      <Container className="child-container">
        <Row>
          <h2 className="mb-3 mt-5">Register Page</h2>
        </Row>
        <Row>
          <Col md={8}>
            <Card>
                <Card.Body>
                {this.state.successfullyRegistered
                  ? "Successfully registered with email: " + this.state.email + ". Please tell an admin to confirm your registration."
                  : this.renderRegistrationForm()}
                  <label id="terms-label" class="checkbox-inline"><input type="checkbox" required="required"/> I accept the <a href="#">Terms of Use</a> &amp; <a href="#">Privacy Policy</a></label>
                </Card.Body>
            </Card>
            <div class="text-center">Already have an account? <a href="/login">Sign in</a></div>
          </Col>
        </Row>
      </Container>
    );
  }
}

RegisterPage.propTypes = {
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired
};
